import React from 'react';
import { TextFieldElement } from 'react-hook-form-mui';
import type { CmsEditableEmailFieldData } from '@/services/cms/userDefinedForm/CmsEditableEmailFieldData';

export type EditableEmailFieldProps = CmsEditableEmailFieldData;

export function EditableEmailField(props: EditableEmailFieldProps) {
    return <TextFieldElement label={props.title} name={props.name} required={props.required} type="email" fullWidth={true} />;
}
